
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.5 18.75v-3.129a1.5 1.5 0 00-.439-1.06L20.25 12.75H3.75l-1.811 1.811a1.5 1.5 0 00-.439 1.06v3.129a1.5 1.5 0 001.5 1.5h18a1.5 1.5 0 001.5-1.5zM17.669 6.75a1.5 1.5 0 011.423 1.026l1.158 4.974H3.75l1.158-4.974A1.5 1.5 0 016.331 6.75M4.5 15.75H6M18 15.75h1.5M6 21.75a1.5 1.5 0 01-3 0v-1.5h3v1.5zM21 21.75a1.5 1.5 0 11-3 0v-1.5h3v1.5z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M15 3.75a3 3 0 01-6 0h6zM10.5 3.75v-3M13.5 3.75v-3M12 9.75v-3","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    